export default {"src":"/_next/static/media/priority_medium.8869ef39.svg","height":141,"width":132,"blurWidth":0,"blurHeight":0};